import { Reveal } from "./Reveal";

export const BrandBand = () => (
    <section
        data-testid="brand-band"
        className="relative px-3 md:px-6 my-6"
    >
        <Reveal>
            <div className="relative rounded-[2rem] overflow-hidden border-4 border-[#F1F1EF] shadow-[0_35px_80px_-30px_rgba(211,160,167,0.35)]">
                <img
                    src="/images/dark-gallery-banner.png"
                    alt="Savv Media — unearthing insights, creating demand, scaling impact. Savv strategies."
                    data-testid="brand-band-image"
                    className="w-full h-[36vh] md:h-[58vh] object-cover object-center block"
                />
            </div>
        </Reveal>
    </section>
);
